import { firebase } from '@/services'
import { Profile } from '@/types'
import { TypeGuards } from '@codeleap/types'
import { userHasSocialLogin } from './utils'
import { Settings, navigation } from '@/config'

const verify = (v: any) => !TypeGuards.isNil(v)

type CheckSignupCompletionResult = {
  isComplete: boolean
  nextStep: AppRoute | null
}

export async function checkSignupCompletion(data: Profile): Promise<CheckSignupCompletionResult> {
  const firebaseUser = firebase.auth.currentUser

  const { hasSocialLogin } = await userHasSocialLogin()

  const emailNotVerified = (!firebaseUser?.emailVerified && data?.id === firebaseUser?.uid)

  if (!!firebaseUser && emailNotVerified && Settings.AppConfig.emailVerificationEnabled) {
    if (!hasSocialLogin && !navigation.isCurrentRoute('Auth.VerifyEmail')) {
      return {
        isComplete: false,
        nextStep: 'Auth.VerifyEmail',
      }
    }
  }

  if (!Settings.AppConfig.signupCompleteVerificationEnabled) {
    return {
      isComplete: true,
      nextStep: null,
    }
  }

  const signupInfo = [
    data.first_name,
    data.last_name,
    data.email,
  ]

  const hasCompletedSignup = signupInfo.every(verify)

  const steps = [
    ['Signup', hasCompletedSignup],
  ] as const

  const nextStep = steps.find(x => !x[1])?.[0]
  const isComplete = steps.every(x => x[1])

  return {
    isComplete,
    nextStep: `Auth.${nextStep}`,
  }
}